import { Component, OnInit } from '@angular/core';
import { AlertService } from 'src/app/services/alert.service';

@Component({
  selector: 'app-pre-checkout-viagem',
  templateUrl: './pre-checkout-viagem.component.html',
  styleUrls: ['./pre-checkout-viagem.component.css']
})
export class PreCheckoutViagemComponent implements OnInit {

  enableSemRota: boolean = false;
  enableComRota: boolean = false;

  constructor(private alertService: AlertService) { }

  ngOnInit(): void {
    //Limpa mensagem ao iniciar o componente
    this.alertService.limpaAlertMessage();
  }

}
